import React, { useRef, useEffect, useState } from 'react';

const Canvas = ({ selectedFont, lineStyle, sampleText, deviceType }) => {
  const canvasRef = useRef(null);
  const [isDrawing, setIsDrawing] = useState(false);

  useEffect(() => {
    const canvas = canvasRef.current;
    canvas.width = window.innerWidth;
    canvas.height = window.innerHeight;
    const ctx = canvas.getContext('2d');

    // Clear canvas before drawing lines
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    ctx.lineWidth = 2;
    ctx.lineCap = 'round';
    ctx.strokeStyle = '#000';

    // Draw line guides based on style
    if (lineStyle === 'ruled') {
      for (let y = 50; y < canvas.height; y += 50) {
        ctx.beginPath();
        ctx.moveTo(0, y);
        ctx.lineTo(canvas.width, y);
        ctx.strokeStyle = '#ddd';
        ctx.stroke();
      }
    } else if (lineStyle === 'grid') {
      ctx.strokeStyle = '#eee';
      for (let y = 50; y < canvas.height; y += 50) {
        ctx.beginPath();
        ctx.moveTo(0, y);
        ctx.lineTo(canvas.width, y);
        ctx.stroke();
      }
      for (let x = 50; x < canvas.width; x += 50) {
        ctx.beginPath();
        ctx.moveTo(x, 0);
        ctx.lineTo(x, canvas.height);
        ctx.stroke();
      }
    } else if (lineStyle === 'dotted') {
      ctx.fillStyle = '#ccc';
      for (let y = 25; y < canvas.height; y += 50) {
        for (let x = 25; x < canvas.width; x += 50) {
          ctx.beginPath();
          ctx.arc(x, y, 2, 0, Math.PI * 2);
          ctx.fill();
        }
      }
    }

    // Draw sample text
    ctx.font = `24px ${selectedFont}`;
    ctx.fillStyle = 'rgba(0,0,0,0.2)';
    ctx.fillText(sampleText[0], 50, 100);
    ctx.fillText(sampleText[1], 50, 150);
  }, [lineStyle, sampleText, selectedFont]);

  const getCoordinates = (e) => {
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    if (deviceType === 'mobile' && e.touches) {
      return {
        x: e.touches[0].clientX - rect.left,
        y: e.touches[0].clientY - rect.top,
      };
    } else {
      return {
        x: e.nativeEvent.offsetX,
        y: e.nativeEvent.offsetY,
      };
    }
  };

  const startDrawing = (e) => {
    const ctx = canvasRef.current.getContext('2d');
    const { x, y } = getCoordinates(e);
    ctx.beginPath();
    ctx.moveTo(x, y);
    setIsDrawing(true);
  };

  const draw = (e) => {
    if (!isDrawing) return;
    const ctx = canvasRef.current.getContext('2d');
    const { x, y } = getCoordinates(e);
    ctx.lineTo(x, y);
    ctx.stroke();
  };

  const stopDrawing = () => {
    setIsDrawing(false);
  };

  return (
    <canvas
      ref={canvasRef}
      onMouseDown={deviceType === 'desktop' ? startDrawing : null}
      onMouseMove={deviceType === 'desktop' ? draw : null}
      onMouseUp={deviceType === 'desktop' ? stopDrawing : null}
      onMouseLeave={deviceType === 'desktop' ? stopDrawing : null}
      onTouchStart={deviceType === 'mobile' ? startDrawing : null}
      onTouchMove={deviceType === 'mobile' ? draw : null}
      onTouchEnd={deviceType === 'mobile' ? stopDrawing : null}
      style={{ touchAction: 'none', border: '1px solid #ccc' }}
    />
  );
};

export default Canvas;
